import { useEffect, useMemo, useState } from "react";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import * as R from "ramda";
import { BlogQueryParams } from "components/Blog/Blog.constants";
import { TFilterCategory, TFiltersData } from "components/Blog/Blog.types";
import { Loader } from "shared";
import { PAGINATION_OPTIONS } from "shared/Pagination/Pagination.constants";
import { useMedia, useQueryParams } from "hooks";
import BlogFilters from "../BlogFilters";
import BlogList from "../BlogList";
import {
  updateBreadcrumbs,
  updateCanonicalLink,
  updateDocumentTitle,
} from "helpers";
import { isShowAllCategory } from "components/Blog/helpers";
import { TBlogItemProps } from "../BlogItem/BlogItem";
import QueryString from "qs";

type TBlogPageProps = {
  filtersData: TFiltersData;
  BlogItem: React.FC<TBlogItemProps>;
  apiBaseUrl: string;
};

const BlogPage: React.FC<TBlogPageProps> = ({
  filtersData,
  BlogItem,
  apiBaseUrl,
}) => {
  const windowUrl = window.location.href;
  const { isMobile, isTablet } = useMedia();
  const { queryParams, setQueryParams } = useQueryParams();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { category } = useParams();
  const navigate = useNavigate();

  const categoryList = filtersData.FilteringCategories;

  const activeCategory = useMemo(
    () =>
      R.find(
        (cat: TFilterCategory) =>
          cat.Title?.toLowerCase() === category?.toLowerCase() ||
          cat.Title?.toLowerCase() ===
            category?.replaceAll("-", " ").toLowerCase(),
        categoryList
      ),
    [category, categoryList]
  );

  const sortOptions = useMemo(
    () =>
      R.map(
        (sortParameter) => ({
          label: sortParameter.Title,
          value: sortParameter.Id,
        }),
        filtersData.SortParameters
      ) || [],
    [filtersData.SortParameters]
  );

  const defaultQueryParams = useMemo(
    () => ({
      [BlogQueryParams.ActivePage]: 1,
      [BlogQueryParams.PageSize]: PAGINATION_OPTIONS[0].value,
      [BlogQueryParams.SortBy]: sortOptions[0].value,
    }),
    [sortOptions]
  );

  useEffect(() => {
    console.log(QueryString.stringify(queryParams));
    const realQueryParams = R.mergeLeft(queryParams, defaultQueryParams);
    console.log(realQueryParams);

    if (!activeCategory && category) {
      navigate({
        pathname: "/",
        search: `?${createSearchParams({ ...realQueryParams } as any)}`,
      });
    } else {
      if (QueryString.stringify(queryParams) !== "")
        setQueryParams(realQueryParams);
    }

    setIsLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateCanonicalLink(windowUrl);
  }, [windowUrl]);

  useEffect(() => {
    updateDocumentTitle(
      isShowAllCategory(activeCategory) ? "" : activeCategory?.Title
    );
    updateBreadcrumbs(activeCategory);
  }, [activeCategory]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <BlogFilters
        filtersData={filtersData}
        isTablet={isTablet}
        defaultQueryParams={defaultQueryParams}
        apiBaseUrl={apiBaseUrl}
      />
      <BlogList
        activeCategory={activeCategory}
        sortOptions={sortOptions}
        isMobile={isMobile}
        apiBaseUrl={apiBaseUrl}
        sortByText={filtersData.SortByText}
        BlogItem={BlogItem}
        articlesText={filtersData.Articles}
        paginationEndText={filtersData.PaginationEndText}
        paginationStartText={filtersData.PaginationStartText}
        blogItemCtaText={filtersData.BlogItemCtaText}
        defaultQueryParams={defaultQueryParams}
      />
    </>
  );
};

export default BlogPage;
